module.exports = __webpack_public_path__ + "static/media/dmulogo.b31971e8.png";